module.exports = __webpack_public_path__ + "img/risk_matrix_reference.8f60efb6.png";